import { ColumnDef, ModelDef } from '../'
import {codeInputCommonAttrs} from '../constants'

// @ts-ignore
const md5 = require('md5')

const modelName = 'dataImportSettings'

const model: ModelDef = {
  tableName: modelName,
  tableLabel: 'データインポート設定',
  bulkControllable: true,
  useAlgolia: false,
  tableComment: '',
  defaultSort: {
    key: 'createdAt',
    order: 'asc',
  },
  columns: {
    name: {
      label: 'インポート設定名',
      type: 'STRING',
      facet: true,
      unique: true,
      // editable: false,
      // editableOnCreate: true,
      searchable: true,
      // inputHelpText: '名称は後から変更することができませんのでご注意ください。',
      validate: {
        notEmpty: true,
      },
      inputAttrs: { wrapperClass: 'col-4' },
    },
    targetModelName: {
      type: 'SELECT',
      label: 'インポート先モデル',
      editable: false,
      editableOnCreate: true,
      validate: {
        notEmpty: true,
      },
      selections: () => {
        return Object.keys(window.$nuxt.$models).filter(
          (modelName) => window.$nuxt.$models[modelName].tableLabel,
        ) as string[]
      },
      inputAttrs: { wrapperClass: 'col-4' },
    },
    desc: {
      label: 'ロジックの補足説明',
      type: 'TEXT',
      inputAttrs: { wrapperClass: 'col-4' },
    },
    pathThroughOriginalProps: {
      label: 'パススルー取込を実施',
      type: 'BOOLEAN',
      default: false,
      inputAttrs: { wrapperClass: 'col-2' },
      comment:
        'Excel列名(1列目)の項目名をそのまま取り込みます。モデルのカラムとして設定されていない項目名でも、データの属性として保存されます。変換処理前に保存対象へセットされます。',
    },
    useDateConversion: {
      // TODO: 未実装 on ./importServiceWithDataImportSetting.ts
      label: '日付変換を利用する',
      type: 'BOOLEAN',
      default: true,
      inputAttrs: { wrapperClass: 'col-2' },
      visibleOnIndex: false,
      editCallback({ row, newValue, oldValue }) {
        if (newValue !== oldValue && newValue && !row.dateConversionFormat) {
          row.dateConversionFormat = 'yyyy-mm-dd'
        }
        return row
      },
    },
    dateConversionFormat: {
      // TODO: 未実装 on ./importServiceWithDataImportSetting.ts
      label: '日付変換フォーマット',
      type: 'STRING',
      enableIf: { useDateConversion: true },
      default: 'yyyy-mm-dd',
      visibleOnIndex: false,
    },
    useBeforeFormatFunction: {
      label: '変換処理前関数(全件対象)を利用する',
      type: 'BOOLEAN',
      visibleOnIndex: false,
    },
    beforeFormatFunction: {
      label: '変換処理前関数(全件対象)',
      type: 'TEXT',
      comment:
        'async ({originalDataRows}): Promise<any[]> => { (...) } のコンテキストで実行されます。originalDataRowsのプロパティを設定、書き換えください。',
      inputAttrs: {...codeInputCommonAttrs, placeholder: 'originalDataRows = originalDataRows.filter(...)'},
      enableIf: { useBeforeFormatFunction: true },
      visibleOnIndex: false,
    },
    beforeEachRowConvertFunction: {
      label: '1行単位での処理関数(変換前処理)',
      comment:
        'async ({row, sourceDataRow, allSourceDataRows, sourceDataRowIndex}): Promise<row> => { (...); return row } のコンテキストで実行されます。rowのプロパティを設定、書き換えください。',
      type: 'TEXT',
      inputHelpText:
        'ユニークキーの設定などに利用, ユニークキーを定義したい場合には、 idUnHashed プロパティを設定ください。md5関数を通じてidへ変換されます。',
      inputAttrs: codeInputCommonAttrs,
    },
    useAfterFormatFunction: {
      label: '変換処理後関数(全件対象)を利用する',
      type: 'BOOLEAN',
      visibleOnIndex: false,
    },
    afterFormatFunction: {
      label: '変換処理後関数(全件対象)',
      type: 'TEXT',
      comment:
        'async ({formattedDataRows}): Promise<any[]> => { (...) } のコンテキストで実行されます。originalDataRowsのプロパティを設定、書き換えください。',
      inputAttrs: codeInputCommonAttrs,
      enableIf: { useAfterFormatFunction: true },
      visibleOnIndex: false,
    },
    useBeforeSaveFunction: {
      label: '保存処理直前関数(全件対象)を利用する',
      type: 'BOOLEAN',
      visibleOnIndex: false,
    },
    beforeSaveFunction: {
      label: '保存処理直前関数(全件対象)',
      type: 'TEXT',
      comment:
        'async ({formattedDataRows}): Promise<any[]> => { (...) } のコンテキストで実行されます。formattedDataRowsのプロパティを設定、書き換えください。',
      inputAttrs: codeInputCommonAttrs,
      enableIf: { useBeforeSaveFunction: true },
      visibleOnIndex: false,
    },
    useAfterSaveFunction: {
      label: '保存処理後関数(全件対象)を利用する',
      type: 'BOOLEAN',
      visibleOnIndex: false,
    },
    afterSaveFunction: {
      label: '保存処理後関数(全件対象)',
      type: 'TEXT',
      comment:
        'async ({formattedDataRows}): Promise<any[]> => { (...) } のコンテキストで実行されます。formattedDataRowsのプロパティを設定、書き換えください。',
      inputAttrs: codeInputCommonAttrs,
      enableIf: { useAfterSaveFunction: true },
      visibleOnIndex: false,
    },
    excludeFields: {
      enableIf: (row) => !!row.targetModelName,
      type: 'MULTISELECT',
      label: '取込対象外フィールド (保護フィールド)',
      inputAttrs: { wrapperClass: 'col-12' },
      selections($store, record, currentValue, initialValue) {
        return [''].concat(window.$nuxt.$models[record.targetModelName].colNames)
      },
      inputHelpText:
        '指定したフィールドは取込時に更新されず、値が保護されます。各行の変換処理後に除外処理を実施します。',
    },
    fields: {
      enableIf: (row) => !!row.targetModelName,
      label: '取り込み列毎の変換処理設定',
      type: 'ARRAY_OF_OBJECT',
      visibleOnIndex: false,
      inputAttrs: {
        wrapperClass: 'col-12',
      },
      minValueLength: 1,
      columns: {
        behavior: {
          label: '取込挙動',
          type: 'SELECT',
          strictSelections: true,
          selections: () => ['direct', 'func', 'passThrough'],
          default: 'direct',
          validate: { notEmpty: true },
          inputAttrs: { wrapperClass: 'col-2' },
        },
        dataCol: {
          type: 'STRING',
          label: '取り込みデータ列名',
          validate: { notEmpty: true },
          inputAttrs: { wrapperClass: 'col-2' },
        },
        tCol: {
          type: 'STRING',
          label: '保存先フィールド名',
          // validate: { notEmpty: true },
          dynamicSelections: true,
          selections($store, record, currentValue, initialValue) {
            const selectedTColNames = record.fields.map((f) => f.tCol)
            return [''].concat(
              window.$nuxt.$models[record.targetModelName].colNames.filter(
                (colName) => selectedTColNames.indexOf(colName) === -1,
              ),
            )
          },
          inputAttrs: { wrapperClass: 'col-2' },
          enableIf: (row, parentRecord) => row.behavior === 'direct',
        },
        tFunc: {
          enableIf: (row, parentRecord) => row.behavior === 'func',
          label: '変換処理関数(オプション)',
          type: 'TEXT',
          comment:
            'async ({row, dataColName, value, sourceDataRow, allSourceDataRows, sourceDataRowIndex}): Promise<row> => { (...); return row } のコンテキストで実行されます。rowのプロパティを設定、書き換えください。',
          inputAttrs: {
            wrapperClass: 'col-5',
          },
          default: '',
        },
        execPriority: {
          type: 'NUMBER',
          label: '処理順',
          inputAttrs: { wrapperClass: 'col-1', placeholder: '0' },
          inputHelpText: '優先度 昇順',
          default: '',
        },
      },
      validate: {
        notEmpty: true,
        doNotDuplicateDataColOrTargetColName: (value, col, modelName, record) => {
          console.log({ value, col, modelName, record })
          if (!value) {
            return false
          }
          // dataCol 重複
          const dupDataCols = value.filter((x, i, self) => self.indexOf(x) !== self.lastIndexOf(x))
          // tCol 重複
          const dupTCols = value.filter((x, i, self) => self.indexOf(x) !== self.lastIndexOf(x))
          if (dupDataCols.length || dupTCols.length) {
            return (
              `${
                dupDataCols.length
                  ? `取り込みデータ列名 "${dupDataCols.join('", "')}" が重複して設定されています。`
                  : ''
              }` +
              `${dupTCols.length ? `保存先フィールド名 "${dupTCols.join('", "')}" が重複して設定されています。` : ''}`
            )
          }
          return false
        },
      },
    },
  },
  showOnSettingMenu: true,
  showOnMainmenu: false,
  beforeSave(row: any, oldData: any) {
    console.log({row})
    return row
  },
  shouldCreateHistoryData: ({ before, after }) => true,
  submenuLinks: [
    {
      to: '/importDataFromExternal',
      label: 'データインポート実行',
    },
  ],
}

export default model

// action to import data
